export const PublicRoutesPath = {
  home: "/",
  register: "register",
  resetPassword: "reset-password",
  forgotPassword: "forgot-password"
};
export const PrivateRoutesPath = {};
